import { AxiosInstance } from 'axios'
import { idItem, ApiResult, Pagging } from '../server.api'
import { apeMinimal } from './apeCorrespondanceShared.types'

// Api interface
export default class Naf2025ModuleApi {
  instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  /*
   * Get
   */
  async getWithCorrespondances(id: number): Promise<ApiResult<naf2025WithCorrespondance>> {
    return this.instance.get(`/Naf2025/${id}`)
  }

  /*
   * Search
   */
  async searchWithCorrespondances(search: naf2025Search): Promise<ApiResult<Pagging<naf2025WithCorrespondance>>> {
    return this.instance.post('/Naf2025/search', search)
  }

  /*
   * Create
   */
  async create(newNaf2025: naf2025Create): Promise<ApiResult<idItem>> {
    return this.instance.post('/Naf2025', newNaf2025)
  }

  /*
   * Update
   */
  async update(newNaf2025: naf2025Update): Promise<ApiResult<idItem>> {
    return this.instance.put('/Naf2025', newNaf2025)
  }

  /*
   * Delete
   */
  async delete(id: number): Promise<ApiResult<idItem>> {
    return this.instance.delete('/Naf2025', { params: { id } })
  }
}

// Types
/*
 * Input
 */
type naf2025Create = {
  code: string
  name: string
  apes: number[]
}

type naf2025Search = {
  name?: string
  code?: string
  page: number
  limit: number
  orderByDes?: boolean
  sortBy?: string
  nameOrCode?: boolean
}

type naf2025Update = {
  id: number
  code: string
  name: string
  apes: number[]
}

/*
 * Output
 */
type naf2025WithCorrespondance = {
  id: number
  code: string
  name: string
  correspondances: apeMinimal[]
}

export { naf2025WithCorrespondance, naf2025Create, naf2025Search, naf2025Update }